export enum NotificationType {
  DailySales = 'สรุปยอดขายประจำวัน',
  MonthlySales = 'สรุปยอดขายประจำเดือน',
  Reviews = 'การรีวิว',
  Payout = 'รายงานยอดโอนออก',
  OutOfStockMenus = 'รายงานเมนูของหมดประจำสัปดาห์',
}
